// NIST SP 800-171 Rev 2 — 110 requirements
// Keys use the plain numeric NIST format (3.1.1, 3.2.1, …)
// Content is equivalent to CMMC Level 2 explanations, re-keyed to NIST IDs.
import CMMC_EXPLANATIONS from '../controlExplanations';

const NIST171_EXPLANATIONS = {};
Object.values(CMMC_EXPLANATIONS).forEach(val => {
  if (val.nist_reference) {
    NIST171_EXPLANATIONS[val.nist_reference] = val;
  }
});

export default NIST171_EXPLANATIONS;
